import React, { useState, useEffect, useMemo } from 'react';
import {
  Row,
  Col,
  Form,
  Card,
  Space,
  DatePicker,
  Select,
  message,
  Image,
  Spin,
  Radio
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
// import moment from 'moment';
import LocalStorage from 'utilities/localStorage';
import Layout from '@/common/Layout';
import truck from '../../images/truck-delivery-done.gif';
// import { getAllMaterialslist } from '@/features/stockCard/redux/slice';
const { RangePicker } = DatePicker;
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getAllMaterialslist } from '@/features/stockCard/redux/slice';
import {
  getPoNumbers,
  downloadOtherReportPdf,
  downloadOtherReportCsv,
  fetchMaterialBatches,
  fetchBinSeries
} from '../../redux/slice';
import debounce from 'lodash/debounce';

const StockReportPage = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { allMaterials } = useSelector((state) => state.stocks);
  const [truckShow, setTruckShow] = useState(false);
  const [dateRange, setDateRange] = useState([moment(), moment()]);
  const [futerdate, setFuterdate] = useState(true);
  const [search, setSearch] = useState('');
  const [materialId, setMaterialId] = useState('');
  const [type, setType] = useState('');
  const [subType, setSubType] = useState('');
  const [poNumbers, setPoNumbers] = useState([]);
  const [batchNumbers, setBatchNumbers] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState('');
  const [binSeriesList, setBinSeriesList] = useState([]);
  const [selectedBinSeries, setSelectedBinSeries] = useState('');
  // const [code, setCode] = useState('');

  useEffect(() => {
    handleGetAllMaterialsList();
    handleGetAllPONumbers();
  }, [search, subType]);

  const handleGetAllMaterialsList = () => {
    let payload = { search };
    dispatch(getAllMaterialslist(payload));
  };

  const handleGetAllPONumbers = () => {
    let payload = { type: subType, search };
    dispatch(getPoNumbers(payload)).then((res) => {
      if (res?.payload?.success) {
        setPoNumbers(res?.payload?.data);
      }
    });
  };
  const user = LocalStorage.getItem('Gravity_user');
  const onFinish = (values) => {
    const fromDate =
      subType === 'till_date'
        ? '2023-04-01'
        : values.fromDate
        ? `${moment(values.fromDate[0]._d).format('YYYY-MM-DD')}`
        : '';
    const toDate =
      subType === 'till_date'
        ? moment().format('YYYY-MM-DD')
        : values.fromDate
        ? `${moment(values.fromDate[1]._d).format('YYYY-MM-DD')}`
        : '';
    const asOfDate = values.asOfDate
      ? `${moment(values.asOfDate._d).format('YYYY-MM-DD')}`
      : '';

    setTruckShow(true);

    // Stock Ledger Summary: streamed .xlsx from a dedicated endpoint (same proven
    // mechanism as the COGS report). Handled here and returned early so the shared
    // CSV/PDF report flow below is left completely untouched.
    if (values.report === 'stock_ledger_summary') {
      const authToken = user?.token;
      fetch(
        `${process.env.REACT_APP_API_URL}/batch_log_book/download_stock_ledger_summary?from_date=${fromDate}&to_date=${toDate}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`,
            'X-Session-Token': user?.session_token || ''
          }
        }
      )
        .then(async (response) => {
          if (!response.ok) {
            const errBody = await response.json().catch(() => null);
            message.error(errBody?.message || 'Failed to download report');
            resetAll();
            return;
          }
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.setAttribute(
            'download',
            `Stock_Ledger_Summary_${fromDate}_to_${toDate}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
          message.success('Stock Ledger Summary downloaded successfully');
          resetAll();
        })
        .catch(() => {
          message.error('Failed to fetch report');
          resetAll();
        });
      return;
    }

    const pdfReports = [
      // 'invoice_tracker',
      'approved_material_status',
      'disqualified_material_status',
      'blocked_material_status',
      'provisional_approved_material_status',
      'jubilant_approved_status',
      // 'dispensing_details_report',
      'receipt_details_report',
      'location_details_report',
      'hold_time_report',
      'ratification_log',
      'material_stock_report',
      'non_moving_type',
      'location_status_report'
    ];

    const isPDF = pdfReports.includes(values.report);

    let params = {};
    if (isPDF) {
      if (values.report === 'material_stock_report') {
        params = { report_type: values.report, material_id: materialId };
        if (selectedBatchId) params.batch_details_id = selectedBatchId;
      } else if (values.report === 'non_moving_type') {
        const months = values.non_moving_period;
        const nmFromDate = moment()
          .subtract(months, 'months')
          .format('YYYY-MM-DD');
        const nmToDate = moment().format('YYYY-MM-DD');
        params = {
          report_type: values.report,
          from_date: nmFromDate,
          to_date: nmToDate
        };
      } else if (values.report === 'location_details_report') {
        params = { report_type: values.report, bin_series: selectedBinSeries };
      } else {
        params =
          subType === 'date_range' || subType === 'till_date'
            ? {
                report_type: values.report,
                from_date: fromDate,
                to_date: toDate
              }
            : values.report === 'receipt_details_report' ||
              values.report === 'hold_time_report' ||
              values.report === 'ratification_log' ||
              values.report === 'location_status_report'
            ? {
                report_type: values.report,
                from_date: fromDate,
                to_date: toDate
              }
            : { report_type: values.report, type: subType, search: materialId };
      }
    } else {
      params =
        values.report === 'invoice_tracker'
          ? { report_type: values.report, type: subType, search: materialId }
          : values.report === 'closing_stock_report'
          ? { report_type: values.report, as_of_date: asOfDate }
          : values.report === 'damage_report'
          ? {
              // Damage report is filtered by material code (required) and,
              // optionally, a specific in-house batch. No date range.
              report_type: values.report,
              material_id: materialId,
              ...(selectedBatchId ? { batch_details_id: selectedBatchId } : {})
            }
          : values.report === 'sampling_report'
          ? {
              // Two mutually exclusive modes. 'date_range' sends only the dates;
              // 'material_wise' sends only material (+ optional batch) and no dates,
              // so the backend's default window covers the batch's full history.
              // Unset filters are omitted entirely, so the query string never
              // carries a literal "undefined".
              report_type: values.report,
              ...(subType === 'material_wise'
                ? {
                    material_id: materialId,
                    ...(selectedBatchId
                      ? { batch_details_id: selectedBatchId }
                      : {})
                  }
                : { from_date: fromDate, to_date: toDate })
            }
          : {
              report_type: values.report,
              from_date: fromDate,
              to_date: toDate,
              material_id: materialId
            };
    }

    if (isPDF) {
      dispatch(downloadOtherReportPdf(params))
        .then((res) => {
          const data = res?.payload;
          if (data?.data) {
            window.open(
              `${process.env.REACT_APP_STORAGE_URL}${data.data
                .split('/')
                .pop()}`,
              '_blank'
            );
            message.success('PDF Report opened successfully');
          } else {
            message.error('Failed to get PDF URL');
          }
          resetAll();
        })
        .catch(() => {
          message.error('Failed to fetch report');
          resetAll();
        });
    } else {
      dispatch(downloadOtherReportCsv(params))
        .then((res) => {
          const data = res?.payload;
          if (data instanceof Blob) {
            const blobUrl = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', `${values.report}.csv`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            message.success('CSV downloaded successfully');
          } else {
            message.error('Failed to download report');
          }
          resetAll();
        })
        .catch(() => {
          message.error('Failed to fetch report');
          resetAll();
        });
    }
  };

  const handleChange = (e) => {
    setType(e);
    // subType only means anything in combination with the selected report, and the
    // Radio.Group renders unselected after a report change — so clear the state too,
    // otherwise a stale value (e.g. 'po_num') leaks in and hides every input.
    setSubType('');
    setMaterialId('');
    form.setFieldsValue({
      material_id: undefined,
      batch_details_id: undefined
    });
    if (e === 'retest_material_report' || e === 'expiry_material_report') {
      setFuterdate(false);
    } else {
      setFuterdate(true);
    }
    if (
      e !== 'material_stock_report' &&
      e !== 'damage_report' &&
      e !== 'sampling_report'
    ) {
      setBatchNumbers([]);
      setSelectedBatchId('');
    }
    if (e === 'location_details_report') {
      dispatch(fetchBinSeries()).then((res) => {
        if (res?.payload?.success) {
          setBinSeriesList(res?.payload?.data || []);
        }
      });
    } else {
      setBinSeriesList([]);
      setSelectedBinSeries('');
    }
  };

  // Debounce the material-code search so we don't fire a request per keystroke.
  const debouncedSetSearch = useMemo(
    () => debounce((value) => setSearch(value), 400),
    []
  );
  useEffect(() => {
    return () => debouncedSetSearch.cancel();
  }, [debouncedSetSearch]);

  const onSearch = (value) => {
    debouncedSetSearch(value);
  };

  const onChange = (value) => {
    setMaterialId(value);
    if (
      type === 'material_stock_report' ||
      type === 'damage_report' ||
      type === 'sampling_report'
    ) {
      // Changing (or clearing) the material always invalidates the batch choice.
      setSelectedBatchId('');
      form.setFieldsValue({ batch_details_id: undefined });
      if (!value) {
        setBatchNumbers([]);
        return;
      }
      dispatch(fetchMaterialBatches({ material_id: value })).then((res) => {
        if (res?.payload?.success) {
          setBatchNumbers(res?.payload?.data || []);
        }
      });
    }
  };

  const resetAll = () => {
    form.resetFields();
    setTruckShow(false);
    setType('');
    setSubType('');
    setSearch('');
    setMaterialId('');
    setDateRange([moment(), moment()]);
    setPoNumbers([]);
    setBatchNumbers([]);
    setSelectedBatchId('');
    setBinSeriesList([]);
    setSelectedBinSeries('');
  };

  const onChangeType = (e) => {
    console.log(e);
    setSubType(e.target.value);
  };

  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Card title={'DOWNLOAD OTHER REPORTS'} className={styles.CustomPanel}>
          <Row gutter={24}>
            <Col xs={24} xl={6} span={12} md={24} sm={24}>
              <FormItem
                label="Other reports"
                name="report"
                rules={[
                  {
                    required: true,
                    message: 'Select Statement'
                  }
                ]}
                className={styles.customLable}
              >
                <Select
                  placeholder="Please select report"
                  showSearch
                  optionFilterProp="children"
                  onChange={(e) => handleChange(e)}
                >
                  {user?.user?.role === 'finance_user' && (
                    <>
                      <option value="material_receipt_report">
                        Material receipt report
                      </option>
                      <option value="closing_stock_report">
                        Closing stock report
                      </option>
                      <option value="material_issue_report">
                        Material issue report
                      </option>
                    </>
                  )}
                  <option value="stock_ledger_summary">
                    Stock ledger summary report
                  </option>
                  <option value="stock_reconsiliation">
                    Stock reconciliation
                  </option>
                  <option value="wastage_material_transactions_stock">
                    Wastage material
                  </option>
                  <option value="retest_material_report">
                    Retest material
                  </option>
                  <option value="expiry_material_report">
                    Expiry material
                  </option>
                  <option value="damage_report">Damage report</option>
                  <option value="non_moving_type">Non moving stock</option>
                  <option value="material_stock_report">
                    Material stock report
                  </option>
                  <option value="invoice_tracker">
                    Invoice tracker report
                  </option>
                  <option value="approved_material_status">
                    Approved vendor report
                  </option>
                  <option value="disqualified_material_status">
                    Disqualified vendor report
                  </option>
                  <option value="blocked_material_status">
                    Blocked vendor report
                  </option>
                  <option value="provisional_approved_material_status">
                    Provisionally approved vendor report
                  </option>
                  <option value="jubilant_approved_status">
                    Jubilant approved vendor report
                  </option>
                  <option value="dispensing_details_report">
                    Dispensing details report
                  </option>
                  <option value="receipt_details_report">
                    Receipt details report
                  </option>
                  <option value="sampling_report">Sampling report</option>
                  <option value="product_line_clearance_report">
                    Product line clearance report
                  </option>
                  <option value="location_details_report">
                    Location details report
                  </option>
                  <option value="location_status_report">
                    Location status report
                  </option>
                  <option value="hold_time_report">Hold time report</option>
                  <option value="closing_stock_report">
                    Closing stock report
                  </option>
                  {/* <option value="ratification_log">Ratification report</option> */}
                </Select>
              </FormItem>
            </Col>
            {
              <>
                {type === 'invoice_tracker' && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Select Type"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group onChange={onChangeType}>
                        <Radio value="po_num">PO no.</Radio>
                        <Radio value="invoice_num">Invoice no.</Radio>
                        <Radio value="date_range">Date</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                )}
                {(type === 'approved_material_status' ||
                  type === 'disqualified_material_status' ||
                  type === 'blocked_material_status' ||
                  type === 'provisional_approved_material_status' ||
                  type === 'jubilant_approved_status') && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Select Type"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group onChange={onChangeType}>
                        <Radio value="date_range">Date range</Radio>

                        <Radio value="till_date">Till date</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                )}
                {/* Sampling report runs in one of two mutually exclusive modes:
                    by date range (material unknown), or by material — optionally
                    narrowed to a single in-house batch — with no date bound. */}
                {type === 'sampling_report' && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Select Type"
                      className={styles.customLable}
                    >
                      <Radio.Group onChange={onChangeType} value={subType}>
                        <Radio value="date_range">Date range</Radio>
                        <Radio value="material_wise">Material wise</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                )}
                {subType === 'po_num' ? (
                  <Col xs={24} xl={12} span={12} md={24} sm={24}>
                    <FormItem
                      label="Enter PO Number"
                      name="po_no"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select a PO number"
                        optionFilterProp="children"
                        onChange={(e) => onChange(e, 'id')}
                        onSearch={onSearch}
                      >
                        {poNumbers ? (
                          poNumbers?.map((item, index) => {
                            return (
                              <option value={item.po_no} key={index}>
                                {item.po_no}
                              </option>
                            );
                          })
                        ) : (
                          <Spin />
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                ) : subType === 'invoice_num' ? (
                  <Col xs={24} xl={12} span={12} md={24} sm={24}>
                    <FormItem
                      label="Enter Invoice Number"
                      name="inv_no"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select a Invoice number"
                        optionFilterProp="children"
                        onChange={(e) => onChange(e, 'id')}
                        onSearch={onSearch}
                      >
                        {poNumbers ? (
                          poNumbers?.map((item, index) => {
                            return (
                              <option value={item.invoice_no} key={index}>
                                {item.invoice_no}
                              </option>
                            );
                          })
                        ) : (
                          <Spin />
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                ) : type === 'closing_stock_report' ? (
                  <Col xs={24} xl={12} span={12} md={24} sm={24}>
                    <FormItem
                      label="Select date"
                      name="asOfDate"
                      rules={[
                        {
                          required: true,
                          message: 'Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <DatePicker
                        format={'DD-MM-YYYY'}
                        disabledDate={(current) =>
                          current && current.valueOf() > Date.now()
                        }
                        style={{ width: '100%' }}
                      />
                    </FormItem>
                  </Col>
                ) : (
                  (subType === 'date_range' ||
                    type === 'stock_reconsiliation' ||
                    type === 'stock_ledger_summary' ||
                    type === 'dispensing_details_report' ||
                    type === 'receipt_details_report' ||
                    type === 'hold_time_report' ||
                    type === 'material_receipt_report' ||
                    type === 'material_issue_report' ||
                    type === 'ratification_log' ||
                    type === 'product_line_clearance_report' ||
                    type === 'location_status_report') && (
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Select start and end date"
                        name="fromDate"
                        rules={[
                          {
                            required: true,
                            message: 'Enter Select date'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <RangePicker
                          format={'DD-MM-YYYY'}
                          onChange={(x) => {
                            setDateRange(x);
                          }}
                          disabledDate={
                            futerdate
                              ? (current) => {
                                  return (
                                    current && current.valueOf() > Date.now()
                                  );
                                }
                              : false
                          }
                          value={dateRange}
                          // separator={'-'}
                          style={{ width: '100%' }}
                        />
                      </FormItem>
                    </Col>
                  )
                )}
                {type !== 'invoice_tracker' ||
                  type !== 'approved_material_status' ||
                  (type !== 'disqualified_material_status' && (
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Select start and end date"
                        name="fromDate"
                        rules={[
                          {
                            required: true,
                            message: 'Enter Select date'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <RangePicker
                          format={'DD-MM-YYYY'}
                          onChange={(x) => {
                            setDateRange(x);
                          }}
                          disabledDate={
                            futerdate
                              ? (current) => {
                                  return (
                                    current && current.valueOf() > Date.now()
                                  );
                                }
                              : false
                          }
                          value={dateRange}
                          // separator={'-'}
                          style={{ width: '100%' }}
                        />
                      </FormItem>
                    </Col>
                  ))}
                {type === 'non_moving_type' && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Non Moving Since"
                      name="non_moving_period"
                      rules={[
                        {
                          required: true,
                          message: 'Select period'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group>
                        <Radio value={3}>3 Months</Radio>
                        <Radio value={6}>6 Months</Radio>
                        <Radio value={9}>9 Months</Radio>
                        <Radio value={12}>12 Months</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                )}
                {type === 'location_details_report' && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Bin Series"
                      name="bin_series"
                      rules={[
                        {
                          required: true,
                          message: 'Select Bin Series'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select bin series"
                        optionFilterProp="children"
                        onChange={(e) => setSelectedBinSeries(e)}
                      >
                        {binSeriesList?.map((series, index) => {
                          return (
                            <option value={series} key={index}>
                              {series}
                            </option>
                          );
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                )}
                {/* Material-wise mode: material code is required (it is the only
                    filter, so without it the report would be a full dump) and the
                    in-house batch narrows it further. Its own block rather than the
                    material_stock_report / damage_report one below so the batch
                    select can stay optional and the labels can differ. */}
                {type === 'sampling_report' && subType === 'material_wise' && (
                  <>
                    <Col xs={24} xl={6} span={6} md={24} sm={24}>
                      <FormItem
                        label="Material Code"
                        name="material_id"
                        rules={[
                          {
                            required: true,
                            message: 'Select Material Code'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Select
                          showSearch
                          placeholder="Select a material code"
                          optionFilterProp="children"
                          onChange={(e) => onChange(e, 'id')}
                          onSearch={onSearch}
                        >
                          {allMaterials ? (
                            allMaterials?.map((item, index) => {
                              return (
                                <option value={item.id} key={index}>
                                  {item.code}
                                </option>
                              );
                            })
                          ) : (
                            <Spin />
                          )}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col xs={24} xl={6} span={6} md={24} sm={24}>
                      <FormItem
                        label="Inhouse Batch No (optional)"
                        name="batch_details_id"
                        className={styles.customLable}
                      >
                        <Select
                          showSearch
                          allowClear
                          placeholder={
                            materialId
                              ? 'All batches of this material'
                              : 'Select a material code first'
                          }
                          optionFilterProp="children"
                          onChange={(e) => setSelectedBatchId(e)}
                          disabled={!materialId}
                        >
                          {batchNumbers?.map((item, index) => {
                            return (
                              <option value={item.id} key={index}>
                                {item.inhouse_batch_number}
                              </option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </Col>
                  </>
                )}
                {(type === 'material_stock_report' ||
                  type === 'damage_report') && (
                  <>
                    <Col xs={24} xl={6} span={6} md={24} sm={24}>
                      <FormItem
                        label="Material Code"
                        name="material_id"
                        rules={[
                          {
                            required: true,
                            message: 'Select Material Code'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Select
                          showSearch
                          placeholder="Select a material code"
                          optionFilterProp="children"
                          onChange={(e) => onChange(e, 'id')}
                          onSearch={onSearch}
                        >
                          {allMaterials ? (
                            allMaterials?.map((item, index) => {
                              return (
                                <option value={item.id} key={index}>
                                  {item.code}
                                </option>
                              );
                            })
                          ) : (
                            <Spin />
                          )}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col xs={24} xl={6} span={6} md={24} sm={24}>
                      <FormItem
                        label="Inhouse Batch No"
                        name="batch_details_id"
                        className={styles.customLable}
                      >
                        <Select
                          showSearch
                          placeholder="Select inhouse batch"
                          optionFilterProp="children"
                          onChange={(e) => setSelectedBatchId(e)}
                          allowClear
                          disabled={!materialId}
                        >
                          {batchNumbers?.map((item, index) => {
                            return (
                              <option value={item.id} key={index}>
                                {item.inhouse_batch_number}
                              </option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </Col>
                  </>
                )}
              </>
            }
          </Row>
        </Card>
        <br />
        <FormItem className="text-center">
          {truckShow ? (
            <Image
              src={truck}
              preview={false}
              style={{ width: '100px !important', height: '100px' }}
            />
          ) : (
            <Space>
              <CustomButton
                className={styles.inwardButton}
                htmlType="submit"
                type="primary"
              >
                Download
              </CustomButton>
              <CustomButton
                className={styles.inwardButton}
                type="primary"
                ghost
                onClick={() => history.back()}
              >
                Back
              </CustomButton>
            </Space>
          )}
        </FormItem>
      </Form>
    </Layout>
  );
};
export default StockReportPage;
